import { useState } from 'react';
import { faqData } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">5个常见问题 · 快速了解平台</span>
        </div>

        <div className="space-y-3 max-w-3xl">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden transition-all"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-colors ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line`} />
                </div>
              </button>

              <div
                className={`grid transition-all duration-300 ${
                  openIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 md:px-6 pb-5">
                    <div className="pt-3 border-t border-background-200/50">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}